import { Component, Input, OnInit, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as L from 'leaflet';

import { ChatsService } from '../../chats/shared/chats.service';
import { Feedback } from '../shared/feedbacks.model';
import { FeedbacksService } from '../shared/feedbacks.service';

@Component({
  selector: 'app-feedback-edit',
  templateUrl: './feedback-edit.component.html',
  styleUrls: ['./feedback-edit.component.scss']
})

export class FeedbackEditComponent implements OnInit {
  @ViewChildren('container') container;
  feedback: Feedback;
  currentFeedbackStringly: string;
  public assignment: any = {};

  @Input()
  set fb(fb: Feedback) {
    // if (!fb) {
    //   this.feedback = fb;
    // }
    // else {
    if (this.feedback && this.feedback._id !== fb._id) {
      this.feedback.userInfo.isAnonymous = this.isAnonymous;
    }
    this.feedback = fb;
    this.isAnonymous = this.feedback.userInfo.isAnonymous;
    setTimeout(() => { this.setMapView(this.feedback); }, 300)
    if (this.feedback.images.length > 0) {
      this.currentImage = this.feedback.images[0];
    }
    if (!this.feedback.chatId) {
      const chatObject = {
        userInfo: this.feedback.userInfo,
        messages: []
      }
      this.chatService.create(chatObject).subscribe(chat => {
        this.feedback.chatId = chat._id;
        this.service.createChatroom(this.feedback._id, chat._id).subscribe(data => { });
      });
    }
    // if (this.container) {
    //   this.container.toArray()[0].nativeElement.scrollTop = 0;
    // }

    this.openDropdown = false;

    this.currentFeedbackStringly = JSON.stringify(fb);
    // }
  };
  get fb() {
    return this.feedback;
  };

  types: any[];
  currentImage: string;
  isAnonymous: boolean;

  openDropdown = false;
  private map: L.Map;
  private marker: L.Marker;
  constructor(
    private service: FeedbacksService,
    private route: ActivatedRoute,
    private chatService: ChatsService,
    private router: Router
  ) {
  }

  setMapView(feedback: Feedback) {
    if (feedback && this.map && feedback.geo) {
      const coordinates = feedback.geo.geometry.coordinates;
      this.map.setView([coordinates[1], coordinates[0]], 16);
      if (this.marker) {
        this.map.removeLayer(this.marker);
      }
      this.marker = new L.Marker([coordinates[1], coordinates[0]], {
        icon: new L.Icon({
          iconUrl: 'assets/images/marker-icon.png',
          iconSize: [25, 41],
          iconAnchor: [12.5, 41]
        }),
        draggable: (feedback.status === 'created' || feedback.status === 'approved')
      }).addTo(this.map);
      this.marker.on('dragend', (layer) => {
        feedback.geo.geometry.coordinates = [layer.target.getLatLng().lng, layer.target.getLatLng().lat];
      });
    }
  }

  initMap(_this: this) {
    if (!_this.map) {
      this.map = L.map('map', {
        center: L.latLng(10.777093006214637, 106.69547438621521),
        zoom: 16,
        attributionControl: false,
        scrollWheelZoom: 'center'
      });
      L.tileLayer('//map.thongtingiaothong.vn/transport-full/{z}/{x}/{y}.png', {
      }).addTo(this.map);
    }
  }

  ngOnInit() {
    this.route.params.map(p => p.id)
      // .do(this.fb = null)
      .filter(id => !!id)
      .flatMap(id => this.service.get(id))
      .subscribe((fb: Feedback) => {
        this.fb = fb;

        setTimeout(() => this.initMap(this), 100);

        // this.setMapView(this.feedback);

      });

    this.service.getAllTypes().do(types => this.types = types).subscribe();
  }

  chooseImage(image) {
    this.currentImage = image;
  }

  toggleDropdown(status) {
    this.openDropdown = !status;
  }

  chooseType(type: any, status) {
    this.toggleDropdown(status);
    this.feedback.type = type._id;
  }

  // approveFeedback(feedback: Feedback) {
  //   this.service.approveFeedback(feedback, fb => {
  //     this.setMapView(feedback);
  //     this.currentFeedbackStringly = JSON.stringify(fb);
  //   });
  // }

  save(feedback: Feedback) {
    this.service.update(feedback._id, feedback).subscribe(fb => {
      this.currentFeedbackStringly = JSON.stringify(fb);
    });
  }

  // doneFeedback(feedback: Feedback) {
  //   this.service.doneFeedback(feedback, fb => {
  //     this.currentFeedbackStringly = JSON.stringify(fb);
  //   });
  // }

  // rejectFeedback(feedback: Feedback) {
  //   this.service.rejectFeedback(feedback, fb => {
  //     this.currentFeedbackStringly = JSON.stringify(fb);
  //   });
  // }

  getTypeValue(id, key) {
    let value = '';
    if (this.types && this.types.length > 0) {
      this.types.forEach(type => {
        if (id === type._id) {
          value = type[key];
        }
      });
    }
    return value;
  }

  checkFeedback(feedback: Feedback) {
    return this.currentFeedbackStringly === JSON.stringify(feedback);
  }

  assign(fb: Feedback, action: string, assignment: any) {
    this.service.assign(fb._id, action, assignment).subscribe(console.info, console.error);
  }
}



// WEBPACK FOOTER //
// /ng-app/src/app/feedbacks/feedback-edit/feedback-edit.component.ts